import { Fragment } from 'react';

import cn from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';

import Checkmark from '@crehana/icons/outline/Checkmark';
import { parseClassnames } from '@crehana/ui';
// eslint-disable-next-line no-restricted-imports
import { greenMain } from '@crehana/ui/dist/styles/colors';

import { OPTION, OPTION_DARK, OPTION_TRANSPARENCY } from './classnames';
import { MenuItemProps } from './types';

const MenuItem: React.FC<React.PropsWithChildren<MenuItemProps>> = ({
  jsxLabel,
  label,
  selected,
  clampText,
  isDark,
  dark,
  isTransparency,
  transparencyMode,
  className = '',
  datatestid,
  'data-testid': dataTestId,
  href,
  onClick,
  htmlProps,
  ...menuItemProps
}) => {
  let menuItemClassNames = isDark || dark ? OPTION_DARK : OPTION;

  if (isTransparency || transparencyMode) {
    menuItemClassNames = OPTION_TRANSPARENCY;
  }

  const wrapperClassNames = parseClassnames(className, menuItemClassNames);
  const wrapperCss = css`
    transition: ${({ theme }) =>
      theme.transition(['background-color', 'color'])};
  `;

  const renderChildren = () => (
    <Fragment>
      <span
        className={cn(
          'font-poppins font-normal text-16 overflow-hidden max-h-24',
          {
            'pr-16': selected,
            'break-all truncate': clampText,
          },
        )}
      >
        {jsxLabel || label}
      </span>
      {selected && <Checkmark size={24} color={greenMain} />}
    </Fragment>
  );

  if (href) {
    return (
      <a
        className={wrapperClassNames}
        css={wrapperCss}
        data-testid={dataTestId || datatestid}
        href={href}
        onClick={
          onClick as (
            event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
          ) => void | undefined
        }
        {...menuItemProps}
        {...(htmlProps as React.HTMLAttributes<HTMLAnchorElement>)}
      >
        {renderChildren()}
      </a>
    );
  }
  return (
    <button
      type="button"
      className={wrapperClassNames}
      css={wrapperCss}
      data-testid={dataTestId || datatestid}
      onClick={
        onClick as (
          event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        ) => void | undefined
      }
      {...menuItemProps}
      {...(htmlProps as React.HTMLAttributes<HTMLButtonElement>)}
    >
      {renderChildren()}
    </button>
  );
};

export default MenuItem;
